import { useState } from "react";

interface Props {
  requesterName: string;
  onConfirm: (reason: string) => void;
  onCancel: () => void;
  submitting: boolean;
}

export default function DenyDialog({ requesterName, onConfirm, onCancel, submitting }: Props) {
  const [reason, setReason] = useState("");

  return (
    <div className="modal-backdrop" onClick={onCancel}>
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <h2 className="di-h4">Needs Coordination: {requesterName}'s request</h2>
        <p className="di-small">This note is sent back to them.</p>
        <textarea
          className="di-input"
          rows={3}
          autoFocus
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="What needs to be worked out before this can go through?"
        />
        <div className="form-actions">
          <button type="button" className="di-btn di-btn-outline" onClick={onCancel} disabled={submitting}>
            Cancel
          </button>
          <button
            type="button"
            className="di-btn di-btn-primary"
            disabled={!reason.trim() || submitting}
            onClick={() => onConfirm(reason.trim())}
          >
            {submitting ? "Sending…" : "Send & notify"}
          </button>
        </div>
      </div>
    </div>
  );
}
